function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeaderIcon = function SvgHeaderIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer-1",
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "252.99 246.08 246.4 371.55 162.91 367.17 163.61 353.87 169.5 241.69 222.07 244.45 252.99 246.08",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "197.51 336.04 116.96 358.43 83.32 237.36 116.67 228.09 163.87 214.98 194.39 324.82 197.51 336.04",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.16,275.05l-12.24,45.18A9.63,9.63,0,0,1,391.1,327H321.26a5.06,5.06,0,0,1-5.16-6.75l12.25-45.18a9.64,9.64,0,0,1,8.82-6.75H407a5.08,5.08,0,0,1,5.43,4.71A5.15,5.15,0,0,1,412.16,275.05Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.15,363v8.24H287.23V363a6.06,6.06,0,0,1,6.06-6.06h77.79a6.05,6.05,0,0,1,6.07,6.06Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.31,369c-4.31,4.39,16.58,73.37,16.58,73.37-2.28,2-5.64,2.92-8.82,3.34a40.55,40.55,0,0,1-8.81.13s-29.94-72.62-21.7-90.64S320.93,329,320.93,329l2.18-5.4,26.45-3.72,4.37,32.39s-4.34.42-10.87,1.26C325.55,355.75,292.23,361,284.31,369Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.51,303.71c-4.39-.75,26.86-28.15,26.86-28.15l15.07,10.14s-25.64,18.06-29.67,18.55S269.51,303.71,269.51,303.71Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.67,435.09,305,457s1.38,5.63-23.74,3.85l-13.84-1.18Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.36,277.39a18.39,18.39,0,0,1-1-7.43,21.83,21.83,0,0,1,.27-2.55l-1.69-2.68-2.17-3.45,2.51-10s16,3.08,17.2,7.54S324.36,277.39,324.36,277.39Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.24,397a68.31,68.31,0,0,0-21.19,22c-8.81,14.7-15.79,35.38-4.95,38l10.31-.39,19.84-6.81-2.08-4S365.8,455,362.83,455s-6.84.74-8.47-.45,5.71-27.92,21.42-36.83S381.24,397,381.24,397Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.87,457c-13.81,0-11.19-61.93-9.6-65s41.66-4.6,45.61-3.3,19.79,63,11.05,67.93Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.69,403.58l5.88,4.8a.8.8,0,0,1,.09,1.13h0l-4.58,4.94a.78.78,0,0,1-1.1,0h0L404.13,409a.79.79,0,0,1,0-1.1l0,0,4.53-4.21A.78.78,0,0,1,409.69,403.58Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.3,428.79s26.58,2.19,39.63-1.19a11.21,11.21,0,0,1,3.73,5.35c1.19,3.56,3.67,15.74-3.73,18.86s-34,2.52-37.55-1S390.3,428.79,390.3,428.79Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.16,427s.89,17.67,2.67,21.68a9.25,9.25,0,0,1-8.56,0c-4.5-2.38-3.76-17.6-2.87-17.56S379.16,427,379.16,427Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.33,259.88c-.05-76.49,11.45-96.74-30-161.36s-143.06-78.93-219.9-31-97.5,109.57-97.5,109.57-27.88,72,11.3,144.5c35.83,66.32,106.39,104,167.59,135H403.31a110.3,110.3,0,0,0,23.92-28.3C459.1,374.66,415.39,336.37,415.33,259.88Z",
    style: {
      fill: "#0FC200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.33,259.88c-.05-76.49,11.45-96.74-30-161.36s-143.06-78.93-219.9-31-97.5,109.57-97.5,109.57-27.88,72,11.3,144.5c35.83,66.32,106.39,104,167.59,135H403.31a110.3,110.3,0,0,0,23.92-28.3C459.1,374.66,415.39,336.37,415.33,259.88Z",
    style: {
      fill: "#fff",
      opacity: 0.699999988079071,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--exam-sheets--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "252.99 246.08 246.4 371.55 162.91 367.17 163.61 353.87 169.5 241.69 222.07 244.45 252.99 246.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "226.93 319.59 208.12 321.14 213.61 344.83 163.61 353.87 169.5 241.69 222.07 244.45 226.93 319.59",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "252.99 246.08 246.4 371.55 162.91 367.17 163.61 353.87 169.5 241.69 222.07 244.45 252.99 246.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.39,
    y1: 250.27,
    x2: 197.12,
    y2: 251.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.17,
    y1: 254.44,
    x2: 189.95,
    y2: 255.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.95,
    y1: 264.57,
    x2: 242.45,
    y2: 267.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.73,
    y1: 268.74,
    x2: 242.23,
    y2: 272.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.48,
    y1: 273.61,
    x2: 232.78,
    y2: 276.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.36,
    y: 278.19,
    width: 5.09,
    height: 5.09,
    transform: "translate(-107.99 447.64) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.58,
    y: 278.67,
    width: 5.09,
    height: 5.09,
    transform: "translate(-99.74 457.31) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.78,
    y: 279.16,
    width: 5.09,
    height: 5.09,
    transform: "translate(-91.51 466.96) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.99,
    y: 279.64,
    width: 5.09,
    height: 5.09,
    transform: "translate(-83.26 476.62) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62,264.39a1.26,1.26,0,0,1-1.31,1.21h0a1.27,1.27,0,1,1,.13-2.54,1.26,1.26,0,0,1,1.2,1.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.67,
    y1: 288.9,
    x2: 241.17,
    y2: 292.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.45,
    y1: 293.07,
    x2: 240.95,
    y2: 296.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.2,
    y1: 297.94,
    x2: 231.5,
    y2: 300.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.08,
    y: 302.52,
    width: 5.09,
    height: 5.09,
    transform: "translate(-133.51 469.43) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.29,
    y: 303,
    width: 5.09,
    height: 5.09,
    transform: "translate(-125.25 479.08) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.5,
    y: 303.49,
    width: 5.09,
    height: 5.09,
    transform: "translate(-117.02 488.73) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.71,
    y: 303.97,
    width: 5.09,
    height: 5.09,
    transform: "translate(-108.78 498.39) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,288.72a1.27,1.27,0,0,1-1.33,1.21h0a1.28,1.28,0,1,1,1.34-1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.4,
    y1: 313.23,
    x2: 239.89,
    y2: 316.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.18,
    y1: 317.4,
    x2: 239.67,
    y2: 320.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.92,
    y1: 322.26,
    x2: 230.22,
    y2: 325.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.81,
    y: 326.84,
    width: 5.09,
    height: 5.09,
    transform: "translate(-159 491.2) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.1,
    y: 327.31,
    width: 5.1,
    height: 5.1,
    transform: "translate(-149.26 502.8) rotate(-87.14)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0012492197622458px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.22,
    y: 327.82,
    width: 5.09,
    height: 5.09,
    transform: "translate(-142.53 510.51) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.44,
    y: 328.29,
    width: 5.09,
    height: 5.09,
    transform: "translate(-134.26 520.17) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.07,313.05a1.27,1.27,0,0,1-1.33,1.21h0a1.28,1.28,0,1,1,0-2.56h.18a1.27,1.27,0,0,1,1.21,1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.08,
    y1: 338.25,
    x2: 238.57,
    y2: 341.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.86,
    y1: 342.42,
    x2: 238.36,
    y2: 345.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.61,
    y1: 347.29,
    x2: 228.91,
    y2: 350.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.47,
    y: 351.87,
    width: 5.09,
    height: 5.09,
    transform: "translate(-185.25 513.58) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.71,
    y: 352.35,
    width: 5.09,
    height: 5.09,
    transform: "translate(-176.99 523.26) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.92,
    y: 352.84,
    width: 5.09,
    height: 5.09,
    transform: "translate(-168.74 532.91) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.13,
    y: 353.33,
    width: 5.09,
    height: 5.09,
    transform: "translate(-160.51 542.58) rotate(-86.99)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.75,338.08a1.27,1.27,0,1,1-1.2-1.34,1.27,1.27,0,0,1,1.2,1.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "181.23 280.17 181.89 281.31 184.6 278.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "198.39 305.16 199.05 306.3 201.76 303.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "207 330.84 207.66 331.98 210.37 328.98",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "186.6 353.76 187.26 354.89 189.97 351.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.51 336.04 116.96 358.43 83.32 237.36 116.67 228.09 163.87 214.98 194.39 324.82 197.51 336.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "194.39 324.82 132.11 328.85 116.67 228.09 163.87 214.98 194.39 324.82",
    style: {
      fillOpacity: 0.699999988079071,
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "197.51 336.04 116.96 358.43 83.32 237.36 116.67 228.09 163.87 214.98 194.39 324.82 197.51 336.04",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.64,
    y1: 243.62,
    x2: 112.6,
    y2: 237.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.75,
    y1: 247.65,
    x2: 107.01,
    y2: 243.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.5,
    y1: 255.73,
    x2: 160.8,
    y2: 238.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.62,
    y1: 259.75,
    x2: 161.92,
    y2: 243,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.92,
    y1: 264.45,
    x2: 154.35,
    y2: 250.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.96,
    y: 267.88,
    width: 5.09,
    height: 5.09,
    transform: "translate(-68.48 38.66) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.85,
    y: 265.4,
    width: 5.09,
    height: 5.09,
    transform: "translate(-67.49 40.95) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.75,
    y: 262.93,
    width: 5.09,
    height: 5.09,
    transform: "translate(-66.51 43.24) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.62,
    y: 260.47,
    width: 5.09,
    height: 5.09,
    transform: "translate(-65.52 45.52) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.29,256.62a1.27,1.27,0,0,1-2.45.68,1.27,1.27,0,0,1,2.45-.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.02,
    y1: 279.2,
    x2: 167.32,
    y2: 262.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.14,
    y1: 283.23,
    x2: 168.44,
    y2: 266.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.45,
    y1: 287.92,
    x2: 160.87,
    y2: 273.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.49,
    y: 291.35,
    width: 5.09,
    height: 5.09,
    transform: "translate(-74.53 41.26) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.37,
    y: 288.88,
    width: 5.09,
    height: 5.09,
    transform: "translate(-73.54 43.55) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.26,
    y: 286.41,
    width: 5.09,
    height: 5.09,
    transform: "translate(-72.55 45.84) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.16,
    y: 283.93,
    width: 5.09,
    height: 5.09,
    transform: "translate(-71.56 48.13) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.82,280.1a1.28,1.28,0,1,1-1.58-.89h0a1.27,1.27,0,0,1,1.57.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.55,
    y1: 302.68,
    x2: 173.84,
    y2: 285.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.67,
    y1: 306.7,
    x2: 174.96,
    y2: 289.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.97,
    y1: 311.4,
    x2: 167.4,
    y2: 297.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 314.82,
    width: 5.09,
    height: 5.09,
    transform: "translate(-80.57 43.86) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.9,
    y: 312.35,
    width: 5.09,
    height: 5.09,
    transform: "translate(-79.58 46.15) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.78,
    y: 309.88,
    width: 5.09,
    height: 5.09,
    transform: "translate(-78.6 48.44) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.67,
    y: 307.41,
    width: 5.09,
    height: 5.09,
    transform: "translate(-77.61 50.73) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34,303.57a1.28,1.28,0,1,1-1.58-.89h0a1.27,1.27,0,0,1,1.57.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.26,
    y1: 326.82,
    x2: 180.55,
    y2: 310.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.37,
    y1: 330.85,
    x2: 181.67,
    y2: 314.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.68,
    y1: 335.54,
    x2: 174.11,
    y2: 321.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.71,
    y: 338.97,
    width: 5.09,
    height: 5.09,
    transform: "translate(-86.79 46.54) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.61,
    y: 336.5,
    width: 5.09,
    height: 5.09,
    transform: "translate(-85.81 48.83) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.5,
    y: 334.03,
    width: 5.09,
    height: 5.09,
    transform: "translate(-84.82 51.12) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.38,
    y: 331.56,
    width: 5.09,
    height: 5.09,
    transform: "translate(-83.83 53.41) rotate(-15.53)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,327.71a1.28,1.28,0,0,1-2.46.71,1.29,1.29,0,0,1,.88-1.59h0a1.28,1.28,0,0,1,1.57.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "115.04 267.78 116.03 268.65 117.65 264.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "112.63 293.97 113.62 294.84 115.23 291.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "119.15 317.2 120.14 318.07 121.75 314.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "143.62 336.23 144.61 337.1 146.23 333.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.98,
    y: 190.72,
    width: 83.6,
    height: 125.65,
    transform: "translate(-23.48 17.41) rotate(-5.49)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.25,
    y1: 202.64,
    x2: 150.91,
    y2: 200.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.65,
    y1: 206.8,
    x2: 144.38,
    y2: 205.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.87,
    y1: 216.11,
    x2: 198.16,
    y2: 210.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.27,
    y1: 220.26,
    x2: 198.56,
    y2: 214.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.74,
    y1: 225.11,
    x2: 189.87,
    y2: 220.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.67,
    y: 229.24,
    width: 5.09,
    height: 5.09,
    transform: "translate(-21.53 14.48) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.86,
    y: 228.36,
    width: 5.09,
    height: 5.09,
    transform: "translate(-21.41 15.35) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 227.48,
    width: 5.09,
    height: 5.09,
    transform: "translate(-21.28 16.23) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.22,
    y: 226.59,
    width: 5.09,
    height: 5.09,
    transform: "translate(-21.15 17.1) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56,216.43a1.28,1.28,0,1,1-1.4-1.15h0a1.27,1.27,0,0,1,1.39,1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.2,
    y1: 240.36,
    x2: 200.49,
    y2: 234.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.6,
    y1: 244.52,
    x2: 200.89,
    y2: 238.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.07,
    y1: 249.37,
    x2: 192.2,
    y2: 244.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 253.49,
    width: 5.09,
    height: 5.09,
    transform: "translate(-23.84 14.81) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.19,
    y: 252.61,
    width: 5.09,
    height: 5.09,
    transform: "translate(-23.72 15.69) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.37,
    y: 251.73,
    width: 5.09,
    height: 5.09,
    transform: "translate(-23.59 16.56) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.55,
    y: 250.86,
    width: 5.09,
    height: 5.09,
    transform: "translate(-23.46 17.44) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.89,240.68a1.28,1.28,0,1,1-1.4-1.15h0A1.28,1.28,0,0,1,134.89,240.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.53,
    y1: 264.61,
    x2: 202.82,
    y2: 258.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.93,
    y1: 268.77,
    x2: 203.22,
    y2: 262.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.4,
    y1: 273.62,
    x2: 194.53,
    y2: 268.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.33,
    y: 277.74,
    width: 5.09,
    height: 5.09,
    transform: "translate(-26.15 15.15) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.51,
    y: 276.86,
    width: 5.09,
    height: 5.09,
    transform: "translate(-26.02 16.02) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.7,
    y: 275.98,
    width: 5.09,
    height: 5.09,
    transform: "translate(-25.9 16.9) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.88,
    y: 275.1,
    width: 5.09,
    height: 5.09,
    transform: "translate(-25.77 17.77) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,264.93a1.27,1.27,0,1,1-1.38-1.15,1.27,1.27,0,0,1,1.38,1.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.93,
    y1: 289.56,
    x2: 205.22,
    y2: 283.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.33,
    y1: 293.71,
    x2: 205.62,
    y2: 287.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.79,
    y1: 298.56,
    x2: 196.92,
    y2: 293.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.73,
    y: 302.69,
    width: 5.09,
    height: 5.09,
    transform: "translate(-28.53 15.49) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.92,
    y: 301.81,
    width: 5.09,
    height: 5.09,
    transform: "translate(-28.4 16.37) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.09,
    y: 300.92,
    width: 5.09,
    height: 5.09,
    transform: "translate(-28.27 17.24) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.28,
    y: 300.04,
    width: 5.09,
    height: 5.09,
    transform: "translate(-28.15 18.11) rotate(-5.49)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.61,289.87a1.28,1.28,0,1,1-1.39-1.14,1.27,1.27,0,0,1,1.39,1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "139.44 231.35 140.26 232.38 142.5 229.02",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "160.11 253.53 160.93 254.56 163.16 251.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "153.3 279.17 154.12 280.2 156.36 276.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "173.93 302.16 174.75 303.19 176.99 299.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bubble--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.15,137.71H255.48a6.88,6.88,0,0,0-6.88,6.88h0V189a6.88,6.88,0,0,0,6.88,6.88h22.9l13.12,15.81-3.29-15.81h18.94A6.88,6.88,0,0,0,314,189V144.59A6.88,6.88,0,0,0,307.15,137.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.45,162.07v-4.7l-3.52-.3a10.2,10.2,0,0,0-.87-2.11l2.27-2.7L280,148.94l-2.7,2.27a9.48,9.48,0,0,0-2.11-.87l-.3-3.52h-4.7l-.3,3.52a9.48,9.48,0,0,0-2.11.87l-2.7-2.27-3.33,3.32L264,155a10,10,0,0,0-.88,2.11l-3.52.3v4.7l3.52.31a10,10,0,0,0,.88,2.11l-2.28,2.7,3.33,3.32,2.7-2.27a9.48,9.48,0,0,0,2.11.87l.3,3.52h4.7l.3-3.52a9.48,9.48,0,0,0,2.11-.87l2.7,2.27,3.33-3.32-2.27-2.7a10.2,10.2,0,0,0,.87-2.11Zm-12.91,3.12a5.47,5.47,0,1,1,5.46-5.48h0a5.45,5.45,0,0,1-5.45,5.47Z",
    style: {
      fill: "#0FC200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,172.56v-3.34l-2.51-.22a6.78,6.78,0,0,0-.62-1.5l1.62-1.92-2.36-2.36-1.93,1.61a7.29,7.29,0,0,0-1.5-.62l-.21-2.5h-3.35l-.21,2.5a7.38,7.38,0,0,0-1.51.62l-1.92-1.61-2.36,2.36,1.61,1.92a6.75,6.75,0,0,0-.61,1.5l-2.51.22v3.34l2.51.22a6.75,6.75,0,0,0,.61,1.5l-1.61,1.92,2.36,2.37,1.92-1.62a6.4,6.4,0,0,0,1.51.62l.21,2.51h3.35l.21-2.51a6.33,6.33,0,0,0,1.5-.62l1.93,1.62,2.36-2.37-1.62-1.92a6.33,6.33,0,0,0,.62-1.5Zm-9.19,2.22a3.89,3.89,0,1,1,3.89-3.89,3.89,3.89,0,0,1-3.89,3.89Z",
    style: {
      fill: "#0FC200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.64,180.35V178l-1.79-.16a4.73,4.73,0,0,0-.44-1.07l1.15-1.36-1.68-1.69-1.37,1.15a5.78,5.78,0,0,0-1.06-.44l-.16-1.78h-2.38l-.15,1.78a5.24,5.24,0,0,0-1.07.44l-1.37-1.15-1.68,1.69,1.15,1.36a5.24,5.24,0,0,0-.44,1.07l-1.78.16v2.37l1.78.16a5.24,5.24,0,0,0,.44,1.07L272.64,183l1.68,1.69,1.37-1.15a5.87,5.87,0,0,0,1.07.44l.15,1.78h2.38l.16-1.78a5.78,5.78,0,0,0,1.06-.44l1.37,1.15,1.68-1.69-1.15-1.36a4.73,4.73,0,0,0,.44-1.07Zm-6.54,1.58a2.77,2.77,0,1,1,2.77-2.77h0a2.77,2.77,0,0,1-2.77,2.76Z",
    style: {
      fill: "#0FC200"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "111.79 425.86 77.78 425.86 81.34 456.95 108.23 456.95 111.79 425.86",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,404.22s-14.85,1.17-15.47,12.13C100.35,416.35,115.39,423.27,115.82,404.22Z",
    style: {
      fill: "#0FC200",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.44,406.94s-8.3-11.22-21.71-5.47C64.73,401.47,72.92,415,86.44,406.94Z",
    style: {
      fill: "#0FC200",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.87,371.52s-2.39,21.58,17.26,15.64C83.13,387.16,76.89,371.29,65.87,371.52Z",
    style: {
      fill: "#0FC200",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,359.5s-15.54,8.38-4.11,21.1C85.88,380.6,96.77,371.51,90,359.5Z",
    style: {
      fill: "#0FC200",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,378.79s-16.9-1.71-16.9,13.93C92.21,392.72,109.11,393.39,109.11,378.79Z",
    style: {
      fill: "#0FC200",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.18,438.67s7.7-16.16.31-32.62-9.9-30.33-6-40.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.56,383S93.43,387,90,397.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.21,380.15s5.85,8,15.76,7.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.21,403.77s16.2,4.66,22.64,3.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,409.15s-7.25,8-14.53,7.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.32,
    y: 425.17,
    width: 36.93,
    height: 4.39,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeaderIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Header-icon.2e0537df.svg";
export { ForwardRef as ReactComponent };